export const SCHEDULE_DEMO_URL =
  'https://meetings.hubspot.com/zoe-colivas/in-app-demo-request-';
export const MEMBERSHIP_SCHEDULE_DEMO_URL_TODAY =
  'https://meetings.hubspot.com/contracall/membership';
export const MEMBERSHIP_SCHEDULE_DEMO_URL_LATER =
  'https://meetings.hubspot.com/contracall/membership-intro';
